const PERMISSION_KEY= "core:user_force_session";
const PAGE_URL = {
    USER_FORCE_SESSION_PAGE: "/admin/core/user-force-session"
}

export {PERMISSION_KEY, PAGE_URL}

